import React from 'react';
import { GridDropdown } from '../../utils/gridUtils';
// import { GridDropdown } from '../../path/to/GridDropdown'; // ✅ update this import path

const AnimationDropdown = ({
  value,
  onChange,
  options = [],
  placeholder = 'Select option',
  className = '',
  disabled = false,
  label = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      {label && (
        <label className="text-[10px] text-gray-400 mb-1 block">{label}</label>
      )}

      <GridDropdown
        className="h-7 flex items-center "
        label=""
        value={value}
        onChange={onChange}
        options={options.length ? options : [{ value: '', label: placeholder }]}
        disabled={disabled}
      />
    </div>
  );
};

export default AnimationDropdown;
